import type { FC } from 'react';
import { MatchMedia } from '@george-labs.com/design-system';

import type { Account } from '@shared/products-types';
import type { ProductWithHelpers } from '@shared/products-core';
import { useActiveProduct } from '@shared/products-core';

import { ProductImageUpload } from '../../ProductImageUpload';
import { ProductAvatar } from '../../../components/ProductAvatar';

export const PersonalizationAvatar: FC = () => {
    const product = useActiveProduct<ProductWithHelpers<Account>>();

    return (
        <MatchMedia max={MatchMedia.TIER.SM}>
            {({ isMatching }) => {
                const size = isMatching ? '64' : '96';

                return (
                    <ProductImageUpload
                        dropdownToggle={
                            <ProductAvatar product={product} size={size} hasColorPreview />
                        }
                        trigger="productIcon"
                        productType={product.type}
                    />
                );
            }}
        </MatchMedia>
    );
};
